import { render } from "./ForgetPasswordVeterinaire.vue?vue&type=template&id=21a4152b"
import script from "./ForgetPasswordVeterinaire.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordVeterinaire.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__